import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../common/DashboardApp";
import {
  getCities,
  getCategories,
  getIndustryData,
  getSalaryTypeData,
  getJobTypeData,
  getExperienceRangeData,
  getOtherFieldData,
  uploadJobPost,
} from "../../../service/employerapi";
import { toast } from "react-toastify";
import Select from "react-select";

const PostJob = () => {
  const [loading, setLoading] = useState(true);
  const [responseCategory, setResponseCategory] = useState([]);
  const [btnloading, setBtnLoading] = useState(false);
  const [responseIndustry, setResponseIndustry] = useState([]);
  const [responseCity, setResponseCity] = useState([]);
  const [responseSalary, setResponseSalary] = useState([]);
  const [responseJobType, setResponseJobType] = useState([]);
  const [responseExpRange, setResponseExpRange] = useState([]);
  const [responseOtherField, setResponseOtherField] = useState([]);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await getCategories();
        if (res.status && res.data) {
          setResponseCategory(res.data.data || []); // take the array
        }

        const resind = await getIndustryData();
        if (resind.status && resind.data) {
          setResponseIndustry(resind.data);
        }

        const rescity = await getCities();
        if (rescity.data.status && rescity.data.data) {
          setResponseCity(rescity.data.data);
        }

        const ressalary = await getSalaryTypeData();
        if (ressalary.status && ressalary.data) {
          setResponseSalary(ressalary.data);
        }

        const resjobtype = await getJobTypeData();
        // console.log(resjobtype);
        if (resjobtype.status && resjobtype.data) {
          setResponseJobType(resjobtype.data);
        }

        const resexprange = await getExperienceRangeData();
        if (resexprange.status && resexprange.data) {
          setResponseExpRange(resexprange.data);
        }

        const resof = await getOtherFieldData();
        if (resof.status && resof.data) {
          setResponseOtherField(resof.data);
        }
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };

    fetchProfile();
  }, []);

  const categoryOptions = Array.isArray(responseCategory)
    ? responseCategory.map((category) => ({
        value: category.name,
        label: category.name,
      }))
    : [];

  const jobOptions = Array.isArray(responseJobType)
    ? responseJobType.map((job) => ({
        value: job.name,
        label: job.name,
      }))
    : [];

  const salaryOptions = Array.isArray(responseSalary)
    ? responseSalary.map((salary) => ({
        value: salary.name,
        label: salary.name,
      }))
    : [];

  const experienceOptions = Array.isArray(responseExpRange)
    ? responseExpRange.map((exp) => ({
        value: exp.name,
        label: exp.name,
      }))
    : [];

  const otherOptions = Array.isArray(responseOtherField)
    ? responseOtherField.map((other) => ({
        value: other.name,
        label: other.name,
      }))
    : [];

  const industryOptions =
    responseIndustry?.map((industry) => ({
      value: industry.name,
      label: industry.name,
    })) || [];

  const cityOptions =
    responseCity?.map((city) => ({
      value: city,
      label: city,
    })) || [];

  const [skills, setSkills] = useState([]);
  const [input, setInput] = useState("");

  const addSkill = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const value = input.trim();
      if (value && !skills.includes(value)) {
        setSkills([...skills, value]);
        setInput("");
      }
    }
  };

  const removeSkill = (skill) => {
    setSkills(skills.filter((s) => s !== skill));
  };

  const [industryType, setIndustryType] = useState(null);
  const [category, setCategory] = useState(null);
  const [salaryType, setSalaryType] = useState(null);
  const [jobType, setJobType] = useState(null);
  const [experience, setExperience] = useState(null);
  const [otherField, setOtherField] = useState(null);
  const [city, setCity] = useState(null);

  const navigate = useNavigate();
  const handleJobPost = async (e) => {
    e.preventDefault();
    try {
      setBtnLoading(true);

      const form = e.target;
      const data = {
        jobTitle: form.jobTitle.value,
        industryType: industryType?.value || "",
        category: category?.value || "",
        salaryType: salaryType?.value || "",
        minSalary: form.minSalary.value,
        maxSalary: form.maxSalary.value,
        displayPhoneNumber: form.displayPhoneNumber.value,
        displayEmail: form.displayEmail.value,
        jobType: jobType?.value || "",
        experience: experience?.value || "",
        // otherField: otherField?.value || "",
        workingShift: form.workingShift.value,
        city: city?.value || "",
        // expiredDate: form.expiredDate.value,
        skills: skills, // your skills array
        jobDescription: form.jobDescription.value,
      };

      console.log(data);
      const response = await uploadJobPost(data);
      navigate("/employer/job-list", {
        state: { toastMessage: response.data.message },
      });
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        // Fallback to generic error message
        toast.error(error.message || "Something went wrong");
      }
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <div className="panelMainWrapper">
        <div className="panelCard">
          <div className="titlSectionu userpaneltitle text-left position-relative">
            <h2>Create a Job Post</h2>
          </div>

          <form onSubmit={handleJobPost}>
            <div className="row hj-form">
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label for="contactPerson">
                    Job Title <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="jobTitle"
                    placeholder="Job Title"
                    required=""
                  />
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label for="gender">
                    Industry Type <span className="text-danger">*</span>
                  </label>
                  <Select
                    name="industryType"
                    options={industryOptions}
                    isSearchable={true}
                    placeholder="Select Industry"
                    value={industryType}
                    onChange={(selected) => setIndustryType(selected)}
                  />
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label for="category">
                    Category <span className="text-danger">*</span>
                  </label>
                  <Select
                    name="category"
                    options={categoryOptions}
                    isSearchable={true}
                    placeholder="Select Category"
                    value={category}
                    onChange={(selected) => setCategory(selected)}
                  />
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label for="salaryType" className="form-label">
                    Salary Type <span className="text-danger">*</span>
                  </label>
                  <Select
                    name="salaryType"
                    options={salaryOptions}
                    isSearchable={true}
                    placeholder="Select Salary Type"
                    value={salaryType}
                    onChange={(selected) => setSalaryType(selected)}
                  />
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <label for="sessionTo" className="form-label">
                  Min Salary
                </label>
                <input
                  type="number"
                  id="sessionTo"
                  name="minSalary"
                  className="form-control"
                  placeholder="Enter min salary"
                />
              </div>
              <div className="col-md-4 mb-3">
                <label for="sessionTo" className="form-label">
                  Max Salary
                </label>
                <input
                  type="number"
                  id="sessionTo"
                  name="maxSalary"
                  className="form-control"
                  placeholder="Enter max salary"
                />
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label for="contactPerson">
                    Display Phone Number <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="displayPhoneNumber"
                    placeholder="Enter Mobile"
                    required=""
                    maxlength="10"
                    minlength="10"
                    pattern="\d{10}"
                  />
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label for="salaryType">
                    Display Email <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    name="displayEmail"
                    placeholder="Email"
                    required=""
                  />
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label for="jobType">
                    Job Type <span className="text-danger">*</span>
                  </label>
                  <Select
                    name="jobType"
                    options={jobOptions}
                    isSearchable={true}
                    placeholder="Select Job Type"
                    value={jobType}
                    onChange={(selected) => setJobType(selected)}
                  />
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <label for="sessionTo" className="form-label">
                  Experience
                </label>
                <Select
                  name="experience"
                  options={experienceOptions}
                  isSearchable={true}
                  placeholder="Select Experience Range"
                  value={experience}
                  onChange={(selected) => setExperience(selected)}
                />
              </div>
              {/* <div className="col-md-4 mb-3">
                <label for="sessionTo" className="form-label">
                  Other Field
                </label>
                <Select
                  name="otherField"
                  options={otherOptions}
                  isSearchable={true}
                  placeholder="Select Other Fields"
                  value={otherField}
                  onChange={(selected) => setOtherField(selected)}
                />
              </div> */}
              <div className="col-md-4 mb-3">
                <label for="sessionTo" className="form-label">
                  Working Shift
                </label>
                <select className="form-select" name="workingShift">
                  <option value="Day">Day</option>
                  <option value="Night">Night</option>
                  <option value="Both">Both</option>
                </select>
              </div>
              <div className="col-md-4 mb-3">
                <label for="city" className="form-label">
                  City
                </label>
                <Select
                  name="city"
                  options={cityOptions}
                  isSearchable={true}
                  placeholder="Select City"
                  value={city}
                  onChange={(selected) => setCity(selected)}
                />
              </div>
              {/* <div className="col-md-4 mb-3">
                <label for="expiredDate" className="form-label">
                  Expired Date
                </label>
                <input
                  type="date"
                  id="expiredDate"
                  name="expiredDate"
                  className="form-control"
                  placeholder="Expired Date"
                  required
                />
              </div> */}
              <div className="col-md-12 mb-3">
                <div className="form-group">
                  <label for="skillSearch">
                    Add Skills <span className="text-danger">*</span>
                  </label>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "5px",
                      border: "1px solid #ccc",
                      padding: "5px",
                      borderRadius: "5px",
                      minHeight: "40px",
                      alignItems: "center",
                    }}
                    onClick={() =>
                      document.getElementById("skillsInput").focus()
                    }
                  >
                    {skills.map((s) => (
                      <span
                        key={s}
                        style={{
                          backgroundColor: "#eb642d",
                          color: "white",
                          padding: "3px 8px",
                          borderRadius: "5px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {s}
                        <span
                          onClick={() => removeSkill(s)}
                          style={{
                            marginLeft: "5px",
                            color: "#ffffff96",
                            cursor: "pointer",
                            fontWeight: "bold",
                          }}
                        >
                          ×
                        </span>
                      </span>
                    ))}
                    <input
                      id="skillsInput"
                      name="skills"
                      type="text"
                      value={input}
                      onChange={(e) => setInput(e.target.value)}
                      onKeyDown={addSkill}
                      placeholder="Type skill & press Enter"
                      style={{
                        flex: 1,
                        border: "none",
                        outline: "none",
                        minWidth: "120px",
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 mb-3">
                <label for="jobDescription" className="form-label">
                  Job Description
                </label>
                <textarea
                  id="jobDescription"
                  name="jobDescription"
                  className="form-control"
                  rows="3"
                  placeholder="Enter job description"
                ></textarea>
              </div>
            </div>
            <button
              type="submit"
              className="mt-4 w-100 normalbtn"
              disabled={btnloading}
            >
              {btnloading ? (
                <span>
                  <i
                    className="fa fa-spinner fa-spin"
                    style={{ marginRight: "8px" }}
                  ></i>
                  Creating...
                </span>
              ) : (
                "Create Job Post"
              )}
            </button>
          </form>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default PostJob;
